
    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '../../../lib/util'
    import AbpBase from '../../../lib/abpbase'
    import warehouseCity from '@/store/entities/warehouse-city';
    import warehouseInfo from '@/store/entities/warehouseInfo';
    import storeaddressInfo from '@/store/entities/back-storeaddress-list'
 
    import Enums from '@/lib/enums'
    import appconst from '@/lib/appconst';
    import Preview from 'vue-photo-preview'
    import 'vue-photo-preview/dist/skin.css'
    Vue.use(Preview);

    class Editapplyreturn {
        id: number;
        expressCompany: string;
        warehouseInfoId: number;
        shipment: string;
        reMark: string;
        //recipientInfo: string;
        phone: string;
        receiptAddress: string;
        receiptPhone: string;
        recipientName: string;
        orderType: number = 0;
        whetherAbroad?: boolean;
        storeId: number = 0;
        imageGuid?: string;
        orderImageGuid: string;
    }
    @Component
        //({
        //    name: "expressrejectioninfo",
        //    components: { ImageStandard}
        //})
    export default class CreateapplyreturnModule extends AbpBase {
        @Prop({ type: Boolean, default: false }) value: boolean;
        applyreturn: Editapplyreturn = new Editapplyreturn();
        warehouseCityId: number = 0;
        warehouseOrderType = Enums.WarehouseOrderType;
        warehouseCityList: Array<warehouseCity> = [];
        warehouseInfoList: Array<warehouseInfo> = [];
        storeaddressList: Array<storeaddressInfo> = [];

       
        whetherAbroadList = Enums.WhetherAbroadStatus;
        isDisplay: string = '';
        imgUrl: string = '';
        orderImgUrl: string = '';
        imgUploadUrl: string = '';
        isReadOnly = false;
        isDisplays: boolean = false;
        isDisplayx: boolean = true;
        created() {
            this.imgUploadUrl = appconst.remoteServiceBaseUrl + "api/services/app/Logistics/UploadLogisticsImg";
            this.getCity();
            //this.getData();
            
        }
      
        headers: any = {
            "Authorization": "Bearer " + window.abp.auth.getToken(),
            ".AspNetCore.Culture": window.abp.utils.getCookieValue("Abp.Localization.CultureName"),
            "Abp.TenantId": window.abp.multiTenancy.getTenantIdCookie()
        };
        submit() {
            this.save();
        }
        handleSuccess(res, file) {
            if (res.success) {
                this.applyreturn.imageGuid = res.result;
                var data = { imageGuid: this.applyreturn.imageGuid, url: null };
                this.$store.commit('backlogistics/getImgUrl', data);
                this.imgUrl = data.url;
            }
        }

        handleOrderSuccess(res, file) {
            if (res.success) {
                this.applyreturn.orderImageGuid = res.result;
                var data = { imageGuid: this.applyreturn.orderImageGuid, url: null };
                this.$store.commit('backlogistics/getImgUrl', data);
                this.orderImgUrl = data.url;
            }
        }

        handleError(res, file) {
            this.$Message.error('上传图片失败。' + res.message);
        }

        save() {
            if (this.applyreturn.warehouseInfoId > 0 && this.applyreturn.storeId > 0) {
                this.applyreturn.warehouseInfoId = 0;
            }
            //this.applyreturn.handleType = Enums.HandleStatus.filter(function (item) { return item.value == 2 })[0].value;
            (this.$refs.applyreturnCreateForm as any).validate(async (valid: boolean) => {
                if (valid) {
                    await this.$store.dispatch({
                        type: 'expressrejectioninfo/createReturn',
                        data: this.applyreturn
                    });
                    (this.$refs.applyreturnCreateForm as any).resetFields();
                    this.$emit('save-success');
                    this.$emit('input', false);
                }
            })
        }
        async getData() {
            
            await this.$store.dispatch({
                type: 'backstoreaddress/getAll',
                data: {}
            })
            var a = new storeaddressInfo();
            //a.id = null;
            //a.storeName = "全部";
            this.storeaddressList = this.$store.state.backstoreaddress.list.filter(function (item) { return item.whetherEffective == true });
            //if (this.storeaddressList.length > 0) {
            //    this.applyreturn.storeId = this.storeaddressList[0].id;
            //}
            //this.storeaddressList.push(a);

        }
        changestatus(a: any) {
            
            if (a == true) {
                this.getData();
                this.isDisplays = true;
                this.isDisplayx = false;

               
               
            }
            else {
                this.isDisplays = false;
                this.isDisplayx = true;
                this.applyreturn.storeId = 0;
            }
        }
        async changeWarehouseCity(val: number) {
            this.warehouseInfoList = await this.$store.dispatch({
                type: 'warehouseInfo/get',
                data: { CityId: val }
            });
            if (this.warehouseInfoList.length == 1) {
                this.applyreturn.warehouseInfoId = this.warehouseInfoList[0].id;
            }
        }
        async getCity() {
            this.warehouseCityList = await this.$store.dispatch({
                type: 'warehouseCity/get',
                data: {}
            });
            if (this.warehouseCityList.length > 0) {
                this.warehouseCityId = this.warehouseCityList[0].id;
                this.changeWarehouseCity(this.warehouseCityId);
            }
        }
        cancel() {
            (this.$refs.applyreturnCreateForm as any).resetFields();
            this.$emit('input', false);
        }
        visibleChange(value: boolean) {
            if (!value) {
                this.$emit('input', value);
            } else {
                //(this.$refs.applyreturnCreateForm as any).resetFields();
                //var data = this.$store.state.frontorderreturn.orderReturnInfo;
                //if (data.id>0) {
                //    this.applyreturn = { id: data.id, warehouseInfoId: data.warehouseInfoId, recipientInfo: "", reMark: "", shipment: data.orderNumber, expressCompany: "虾皮退回" };
                //}
               
                //this.applyreturn.shipment = data.orderNumber;
                //this.applyreturn.expressCompany = "虾皮退回";
            }
        }
        applyreturnRule = {
            warehouseInfoId: [
                { required: true, message: '仓库不能为空', trigger: 'change', type: 'number' }
            ],
            shipment: [
                { required: true, max: 30, message: '快递单号不能为空，且长度必须小于30', trigger: 'blur' }
            ],
            expressCompany: [
                { required: true, max: 30, message: '快递公司不能为空', trigger: 'blur' }
            ],
            reMark: [
                { max: 500, message: '长度不能大于500', trigger: 'blur' }
            ],
            //recipientInfo: [
            //    { required: true,max: 500, message: '收件人信息不能为空', trigger: 'blur' }
            //]
            recipientName: [
                { required: true, max: 30, message: '收件人姓名不能为空', trigger: 'blur' }
            ],
            receiptAddress: [
                { required: true, max: 500, message: '收货地址不能为空', trigger: 'blur' }
            ],
            phone: [
                { required: false, message: this.L('手机号码不能为空'), trigger: 'blur' },
                //{ pattern: /^1[0-9]{10}$/, message: this.L('请输入正确手机号码'), trigger: 'blur' }
            ],
            receiptPhone: [
                { required: false, message: this.L('固话不能为空'), trigger: 'blur' },
                //{ pattern: /^(\d{3,4}-)?\d{6,8}$/, message: this.L('请输入正确号码,为6-8位的座机号码'), trigger: 'blur' }
            ],

        };

    }
